import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { getWaitlistedOrders } from 'src/app/core/constants/endpoints.constant';
import { Class } from 'src/app/core/models/class.model';
import { CrudService } from 'src/app/core/services/data/crud.service';
import { ErrorHandlerService } from 'src/app/core/services/util/error-handler.service';

@Component({
  selector: 'waitlist-modal',
  templateUrl: './waitlist-modal.component.html',
  styleUrls: ['./waitlist-modal.component.scss']
})
export class WaitlistModalComponent implements OnInit {

    unsubscribe: Subject<any> = new Subject();
    waitlistedOrders: any = [];
    isLoadingWaitlist: boolean = true;
    public clazz: any;
    public dialogTitle: string;
    public contentMessage: string;

    constructor(
        public dialogRef: MatDialogRef<WaitlistModalComponent>,
        private crudService: CrudService,
        private errorHandlerService: ErrorHandlerService,
    ) { }

    ngOnInit() {
        this.getWaitlistedOrders();
    }

    private getWaitlistedOrders() {
        this.crudService
        .getAllBy<any>(getWaitlistedOrders.concat(`?classCode=${this.clazz.code}`).concat(`&syCode=${this.clazz.syCode}`))
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(response => {
            if (response) {
                this.waitlistedOrders = response;
                this.isLoadingWaitlist = false;
            }
        }, this.errorHandlerService.handleError);
    }

}
